export const useSaleonthetable = (banners = []) => {
  const tableSectionImage = banners[0] || null; 
  const promoData = banners.slice(1);
  return { tableSectionImage, promoData };
};